import { createAction } from 'redux-actions';
export const CREATE_EXCHANGE_ORDER = 'EXCHANGE/CREATE_EXCHANGE_ORDER';
export const createExchangeOrder = createAction(CREATE_EXCHANGE_ORDER);
export const REFUSE_EXCHANGE_ORDER = 'EXCHANGE/REFUSE_EXCHANGE_ORDER';
export const refuseExchangeOrder = createAction(REFUSE_EXCHANGE_ORDER);
